import DecisionIcon from './DecisionIcon'

export default DecisionIcon
